<template>
  <v-card>
      <v-card-text class="text-xs-center headline primary--text">
          Detalhes da Fatura
      </v-card-text>
      <v-card-text>
       <v-layout wrap justify-space-around>
         <v-flex xs12 class="mb-4">
           <v-layout>
              <v-icon class="mr-2">{{fatura.posto ? 'local_gas_station' : 'business'}}</v-icon>
              <h2>{{fatura.posto ? fatura.posto :  faturaSelecionada.empresa.nome_fantasia}}</h2>
            </v-layout>
          </v-flex>
         <v-flex xs12 class="mb-4" v-if="fatura.data_fatura"><h4>Data da fatura: <b>{{fatura.data_fatura.split('-').reverse().join('/')}}</b></h4></v-flex>
         <template v-if="fatura.posto">
            <v-flex xs5 style="font-size: 1.4em;" v-if="dados.compras_no_posto">
                <v-tooltip left>
                  <v-card slot="activator" color="secondary" style="border-radius: 0.5em;" class="pa-3 white--text" elevation="2">
                    <v-icon class="mr-2" color="white" size="35">local_gas_station</v-icon>
                    <b>{{dados.compras_no_posto | currency({fractionCount: 2})}}</b>
                  </v-card>
                  <span>Pagamento no posto</span>
                </v-tooltip>
            </v-flex>
            <v-flex xs5 class="mb-4" style="font-size: 1.4em;" v-if="dados.compras_no_app">
              <v-tooltip right>
                  <v-card slot="activator" color="primary" style="border-radius: 0.5em;" class="pa-3 white--text" elevation="2">
                    <v-icon class="mr-2" size="35" color="white">stay_primary_portrait</v-icon>
                    <b>{{dados.compras_no_app | currency({fractionCount: 2})}}</b>
                  </v-card>
                  <span>Pagamento no app</span>
              </v-tooltip>
            </v-flex>
            <v-flex xs5 style="font-size: 1.4em;" v-if="dados.compras_empresa">
              <v-tooltip left>
                  <v-card slot="activator" color="success" style="border-radius: 0.5em;" class="pa-3 white--text" elevation="2">
                    <v-icon class="mr-2" color="white" size="35">business</v-icon>
                    <b>{{dados.compras_empresa | currency({fractionCount: 2})}}</b>
                  </v-card>
                  <span>Pagamento de empresas</span>
              </v-tooltip>
            </v-flex>
            <v-flex xs5 style="font-size: 1.4em;" v-if="dados.valor_fatura_mensal">
                <v-tooltip right>
                  <v-card slot="activator" color="info" style="border-radius: 0.5em;" class="pa-3 white--text" elevation="2">
                    <v-icon class="mr-2" color="white" size="35">assignment</v-icon>
                    <b>{{dados.valor_fatura_mensal | currency({fractionCount: 2})}}</b>
                  </v-card>
                  <span>Valor da assinatura</span>
                </v-tooltip>
            </v-flex>
         </template>
         <template v-else-if="fatura.empresa">
           <v-flex xs5 style="font-size: 1.4em;" v-if="dados.compras_empresa">
                <v-tooltip left>
                  <v-card slot="activator" color="success" style="border-radius: 0.5em;" class="pa-3 white--text" elevation="2">
                    <v-icon class="mr-2" color="white" size="35">attach_money</v-icon>
                    <b>{{dados.compras_empresa | currency({fractionCount: 2})}}</b>
                  </v-card>
                  <span>Valor total de compras</span>
                </v-tooltip>
            </v-flex>
            <v-flex xs5 class="mb-4" style="font-size: 1.4em;" v-if="dados.qtd_veiculos">
              <v-tooltip right>
                  <v-card slot="activator" color="primary" style="border-radius: 0.5em;" class="pa-3 white--text" elevation="2">
                    <v-icon class="mr-2" size="35" color="white">commute</v-icon>
                    <b>{{dados.qtd_veiculos}} {{dados.qtd_veiculos > 1 ? 'veículos' : 'veículo'}}</b>
                  </v-card>
                  <span>Quantidade de veículos</span>
              </v-tooltip>
            </v-flex>
            <v-flex xs5 style="font-size: 1.4em;" v-if="dados.valor_assinatura">
              <v-tooltip left>
                  <v-card slot="activator" color="info" style="border-radius: 0.5em;" class="pa-3 white--text" elevation="2">
                    <v-icon class="mr-2" color="white" size="35">assignment</v-icon>
                    <b>{{dados.valor_assinatura | currency({fractionCount: 2})}}</b>
                  </v-card>
                  <span>Valor da assinatura</span>
              </v-tooltip>
            </v-flex>
         </template>
         <template v-else>
           <v-flex>Não foi encontrado o posto ou empresa dessa fatura.</v-flex>
         </template>
         <v-flex xs12>
          <v-flex xs6 style="font-size: 1.1em;" class="mt-4 mb-4" v-if="dados.taxa_por_abastecimento">
            Taxa por abastecimento: {{dados.taxa_por_abastecimento}}%
            <v-btn icon><v-icon color="info" size="20" @click="valor_taxa_abastecimento = !valor_taxa_abastecimento">calculate</v-icon></v-btn>
            <b v-if="valor_taxa_abastecimento">
              {{
                calcular(
                  dados.taxa_por_abastecimento, dados.isPosto ? (dados.compras_no_app ? dados.compras_no_app : 0) + (dados.compras_no_posto ? dados.compras_no_posto : 0) : (dados.compras_empresa ? dados.compras_empresa : 0))
                  | currency({fractionCount: 2})
              }}
            </b>
          </v-flex>
          <v-flex xs6 style="font-size: 1.1em;" class="mt-4 mb-4" v-if="dados.taxa_empresa">
            Taxa por empresa: {{dados.taxa_empresa}}%
            <v-btn icon><v-icon color="info" size="20" @click="valor_taxa_empresa = !valor_taxa_empresa">calculate</v-icon></v-btn>
            <b v-if="valor_taxa_empresa">
              {{calcular(dados.taxa_empresa, dados.compras_empresa ? dados.compras_empresa : 0)
                | currency({fractionCount: 2})
              }}
            </b>
          </v-flex>
          <v-flex xs6 style="font-size: 1.1em;" class="mt-4 mb-4" v-if="dados.taxa_por_veiculo">
            Taxa por veículo: {{ (dados.taxa_por_veiculo || 0) | currency({fractionCount: 2}) }}
            <v-btn icon><v-icon color="info" size="20" @click="valor_taxa_veiculo = !valor_taxa_veiculo">calculate</v-icon></v-btn>
            <b v-if="valor_taxa_veiculo">
              {{ ((dados.taxa_por_veiculo || 0) * (dados.qtd_veiculos || 0)) | currency({fractionCount: 2}) }}
            </b>
          </v-flex>
          </v-flex>
       </v-layout>
        <v-list class="pt-0">
            <template v-for="(detalhe, index) in fatura.tipos_faturamento">
                <v-list-tile :key="index" avatar>
                    <v-list-tile-avatar>
                      <v-tooltip v-if="detalhe.combustivel" bottom>
                          <svg-filler
                            :path="combustiveisJson[detalhe.combustivel].icone ? require(`@/assets/combs/${combustiveisJson[detalhe.combustivel].icone}.svg`) : require(`@/assets/combs/gas.svg`)"
                            width="50px"
                            height="50px"
                            :fill="combustiveisJson[detalhe.combustivel].color"
                            slot="activator"
                          />
                          {{combustiveisJson[detalhe.combustivel].nome}}
                      </v-tooltip>
                      <v-icon color="green" v-else>attach_money</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                        <v-list-tile-title v-text="`Valor: R$ ${detalhe.valor}`" class="font-weight-light">
                        </v-list-tile-title>
                        <v-list-tile-sub-title v-text="detalhe.descricao"></v-list-tile-sub-title>
                    </v-list-tile-content>
                    <v-list-tile-action>
                        <v-tooltip lazy bottom>
                            <v-btn icon slot="activator" @click="abrirEdicao(detalhe)">
                                <v-icon color="info">
                                    edit
                                </v-icon>
                            </v-btn>
                            Editar cobrança
                        </v-tooltip>
                    </v-list-tile-action>
                </v-list-tile>
                <v-divider :key="`divider-${index}`"></v-divider>
            </template>
            <v-tooltip bottom>
                <v-btn slot="activator" block dark depressed outline color="green" class="mt-3" @click="dialogCobranca = true">
                    <v-icon medium>
                        add
                    </v-icon>
                </v-btn>
                Adicionar nova cobrança
            </v-tooltip>
        </v-list>
      </v-card-text>
      <v-dialog width="550" v-model="dialogCobranca" lazy persistent>
        <cad-cobranca :fatura="fatura" @fechar="fecharNovaCobranca()"></cad-cobranca>
      </v-dialog>
      <v-dialog width="550" v-model="dialogEditCobranca" lazy persistent>
        <edit-cobranca :cobranca="cobrancaSelecionada" @fechar="fecharEdicaoCobranca()"></edit-cobranca>
      </v-dialog>
  </v-card>
</template>

<script>
import EditCobranca from '@/components/dialogs/EditCobranca'
import CadCobranca from '@/components/cadastros/CadCobranca'

export default {
  components: {
    CadCobranca,
    EditCobranca
  },
  props: ['faturaSelecionada'],
  data () {
    return {
      fatura: {},
      dados: {},
      dialogCobranca: false,
      dialogEditCobranca: false,
      cobrancaSelecionada: null,
      valor_taxa_empresa: false,
      valor_taxa_abastecimento: false,
      valor_taxa_veiculo: false
    }
  },
  mounted () {
    if (this.faturaSelecionada) {
      this.carregarDetalhes()
      this.pegarDados()
    }
  },
  computed: {
    combustiveis () {
      return this.$store.getters.combustiveis
    },
    combustiveisJson () {
      let json = {}
      this.combustiveis.forEach(comb => {
        json[comb.id_combustivel] = { ...comb }
      })
      return json
    }
  },
  watch: {
    faturaSelecionada (val) {
      if (val) {
        this.carregarDetalhes()
        this.pegarDados()
      }
    }
  },
  methods: {
    calcular (taxa, valor) {
      if (!taxa) return 0
      if (!valor) return 0
      return (valor * (taxa / 100)).toFixed(2)
    },
    fecharNovaCobranca () {
      this.dialogCobranca = false
      this.carregarDetalhes()
      this.$emit('recarregar')
    },
    fecharEdicaoCobranca () {
      this.dialogEditCobranca = false
      this.carregarDetalhes()
      this.$emit('recarregar')
    },
    abrirEdicao (cobranca) {
      this.cobrancaSelecionada = cobranca
      this.dialogEditCobranca = true
    },
    pegarDados () {
      this.$store.dispatch('dadosFatura', this.faturaSelecionada.id).then(json => {
        this.dados = json
      })
    },
    carregarDetalhes () {
      this.$store.dispatch('detalhesFaturamento', this.faturaSelecionada.id).then(json => {
        this.fatura = json
      })
    }
  }
}
</script>
